import { z } from "zod";

const InclusionMetafield = z.object({
  include: z.string().array().optional(),
  exclude: z.string().array().optional(),
});

export type InclusionMetafieldType = z.infer<typeof InclusionMetafield>;
